import React, {useState, useEffect,useRef} from 'react';
import { IoIosAdd } from "react-icons/io";
import './Campaign.scss';
import { FaClock } from "react-icons/fa6";
import 'react-datepicker/dist/react-datepicker.css';
import { GiSandsOfTime } from "react-icons/gi";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import { FaServer } from "react-icons/fa";
import { CiAt } from "react-icons/ci";
import { FaUserFriends } from "react-icons/fa";
import { IoMdSend } from "react-icons/io";
import 'react-quill/dist/quill.snow.css'
 import ReactQuill from 'react-quill';
 import { FaMailBulk } from "react-icons/fa";
 import { IoMdArrowBack } from "react-icons/io";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { CiEdit } from "react-icons/ci";
import { IoClose } from "react-icons/io5";
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
 import 'react-toastify/dist/ReactToastify.css';
 import axios from 'axios';
 import { MdOutlineArrowBackIos } from "react-icons/md";
import { FaGlobe } from "react-icons/fa";
import DatePicker from 'react-datepicker';
import { fromZonedTime, toZonedTime} from 'date-fns-tz';
import 'react-datepicker/dist/react-datepicker.css';
import moment from "moment-timezone";
 

function Campaign() {

   const baseURL =
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  const timezones = moment.tz.names().map((tz) => ({
    label: `${tz} (UTC${moment.tz(tz).format("Z")})`,
    value: tz
  }));
    
 const location = useLocation();
 
 const {  email: navEmail, } = location.state || {};
   const [isOpen, setIsOpen] = useState(false);
   const navigate = useNavigate("")
   const popupRef = useRef(null);
    const [showPopup, setShowPopup] = useState(false);   
    const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
   const [configs, setConfigs] = useState([]);
    const [selectedEmail, setSelectedEmail] = useState("");
     const incomingTemplate = location.state?.selectedTemplate || null;
  const [formData, setFormData] = useState({
      message: incomingTemplate?.message || "",
      scheduleSentTime: "",
      delayBetweenEmails: "",
      isCustom: false,
      recipientList: [],
      subject: "",
      sentStatus: "scheduled",
      createdAt: new Date(),
      openedEmails: [],
      clickedEmails: [],
      bouncedEmails: [],
      domain: "",
      fromEmail: "",
      appPassword: "",
      to: "",
});


    const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
    const fromContacts = location.state?.fromContacts;
    const fromList = location.state?.fromList;
    const fromDraft = location.state?.fromDraft;
    const fromCampaignDraft = location.state?.fromCampaignDraft;
    const individualDraftId = location.state?.individualDraftId;
    const selectedListName = location.state?.selectedListName;
const selectedProfileId = location.state?.openProfileId;
    const [listNames, setListNames] = useState([]);
     const [selectedList, setSelectedList] = useState("");
     const [appPassword, setAppPassword] = useState(formData.appPassword)
     const [emails, setEmails] = useState([]);
     const [firstNames, setFirstNames] = useState([]);
     const [scheduleTime, setScheduleTime] = useState('');
     const [mailDelayMinutes, setMailDelayMinutes] = useState(0);
   const quillRef = useRef(null);
     const [isOpenTemplate, setIsOpenTemplate] = useState(false);
     const [showDraftPopup, setShowDraftPopup] = useState(false);
      const [showIndividualDraftPopup, setShowIndividualDraftPopup] = useState(false);
     const [templates, setTemplates] = useState([]);
     const [templateName, setTemplateName] = useState('');
     const [templateMessage, setTemplateMessage] = useState("");
     const [selectedTemplate, setSelectedTemplate] = useState(incomingTemplate?.name || "");
     const textareaRef = useRef(null);
     const [isCustomDelay, setIsCustomDelay] = useState(false);
     const [customDelay, setCustomDelay] = useState('');
      const [campaignName, setCampaignName] = useState(location.state?.campaignName || "");
    const [isSent, setIsSent] = useState(false);
      const [email, setEmail] = useState('');
       const availableDomains = [...new Set(configs.map(config => config.domain))];
       const [draftNavigation, setDraftNavigation] = useState(null);
      const [draftId, setDraftId] = useState(null); 
      const [selectedTimezone, setSelectedTimezone] = useState("Asia/Kolkata");
       const [displayDate, setDisplayDate] = useState(null);
       const [ipData, setIpData] = useState({ serverIP: "", customerIP: "", revenuIP: "" });

      const tabs =  ["Timing&Schedule", "EmailConfiguration", "Content&Template"];

  const [selectedTab, setSelectedTab] = useState(tabs[0]);
   const [maxStep, setMaxStep] = useState(0);
   const [completedSteps, setCompletedSteps] = useState({});

       const {listName, id } = useParams();
       const now = new Date();
       const pad = (n) => (n < 10 ? "0" + n : n);
       const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`;
     
       const userId = localStorage.getItem('userId');

       useEffect(() => {
    if (selectedTimezone) {
      const nowInSelectedTZ = moment.tz(selectedTimezone).toDate();
      setDisplayDate(nowInSelectedTZ);
    }
  }, [selectedTimezone]);

  useEffect(() => {
  const fetchIPs = async () => {
    try {
      const res = await fetch(`${baseURL}/api/get-ips`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      const data = await res.json();
      setIpData(data);
    } catch (err) {
      console.error("Error fetching IPs:", err);
    }
  };
  fetchIPs();
}, []);
 
useEffect(() => {
    if (location.state?.campaignName) {
      setCampaignName(location.state.campaignName);
    } else {
      // fallback to localStorage
      const savedName = localStorage.getItem("campaignName");
      if (savedName) {
        setCampaignName(savedName);
      }
    }
  }, [location.state]);

       useEffect(() => {
  if (incomingTemplate) {
    setSelectedTemplate(incomingTemplate.name);
    setFormData(prev => ({
      ...prev,
      message: incomingTemplate.message
    }));
  }
}, [incomingTemplate]);

useEffect(() => {
  const handleBeforeUnload = (e) => {
    if (!isSent) {
      e.preventDefault();
      e.returnValue = ""; 
    }
  };
  window.addEventListener("beforeunload", handleBeforeUnload);
  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
}, [isSent]);

useEffect(() => {
  if (navEmail) {
    setEmail(navEmail);
  } else if (fromContacts) {
    fetchEmailById();
  } else if (fromList) {
    fetchListEmailById();
  }
}, [id, fromContacts, fromList, listName, navEmail]);

// useEffect(() => {
//   if (fromContacts && individualDraftId) {
//     fetchEmailById(individualDraftId);
//   } else if (fromList && id && listName) {
//     fetchListEmailById(listName, id);
//   }
// }, [fromContacts, fromList, individualDraftId, id, listName]);


useEffect(() => {
  const draft = location.state?.draft;
  const type = location.state?.type;

  if (draft) {
    if (type === 'campaign') {
      setCampaignName(draft.campaignName);
      setFormData(prev => ({
        ...prev,
        subject: draft.subject,
        message: draft.message,
        domain: draft.domain,
        fromEmail: draft.from,
        appPassword: draft.appPassword,
      }));
      setSelectedEmail(draft.from);
      setEmails(draft.recipientList || []);
      setSelectedList(""); 
    } else if (type === 'individual') {
      setEmail(draft.recipientEmail);
      setFormData(prev => ({
        ...prev,
        subject: draft.subject,
        message: draft.message,
        domain: draft.domain,
        fromEmail: draft.from,
        appPassword: draft.appPassword,
      }));
      setSelectedEmail(draft.from);
    }
  }
}, []);

// useEffect(() => {
//   if (location.state?.isIndividualDraft) {
//     setIndividualDraftId(location.state?.emailId);
//   }
// }, [location.state]);

useEffect(() => {
  if (location.state?.draft) {
    const draft = location.state.draft;
    setDraftId(draft.campaignId);
  }
}, [location.state]);

useEffect(() => {
    if (location.state?.draft) {
      const draft = location.state.draft;
      setDraftId(draft.campaignId);
      setCampaignName(draft.campaignName);
      setScheduleTime(draft.scheduleSentTime);
      setMailDelayMinutes(draft.delayBetweenEmails);
      setEmails(draft.recipientList);
      setFormData({
        ...formData,
        subject: draft.subject,
        message: draft.message,
        fromEmail: draft.from,
        domain: draft.domain,
      });
    }
  }, [location.state]);

  useEffect(() => {
  if (fromDraft && individualDraftId) {
    fetchIndividualDraft(individualDraftId);
  }
}, [fromDraft, individualDraftId]);

const fetchIndividualDraft = async (individualDraftId) => {
  const token = localStorage.getItem('token');
  if (!token) return;

  const res = await fetch(`${baseURL}/api/get-individual-draft/${individualDraftId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json();
  if (data?.draft) {
    setEmail(data.draft.recipientEmail);
    setFormData({
      subject: data.draft.subject,
      message: data.draft.message,
      domain: data.draft.domain,
      appPassword: "", 
    });
    setScheduleTime(data.draft.scheduleTime);
  }
};


       const fetchTemplates = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${baseURL}/api/get-templates`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
     let allTemplates = response.data || [];

       if (incomingTemplate) {
      allTemplates = allTemplates.filter(t => t.name !== incomingTemplate.name);
    }
    setTemplates(response.data || []);
  } catch (error) {
   Swal.fire({
             icon: 'error',
             title: 'Error',
             text: 'Something went wrong!',
             confirmButtonColor: 'red',
           });
  }
};


useEffect(() => {
  fetchTemplates();
  getConfigs();
  fetchListNames();
  fetchEmails();
if(id && listName){
  fetchListEmailById();
}
if(id && !listName){
  fetchEmailById();
}
}, [userId, id, listName, selectedList]);


const handleScheduleChange = (e) => {
  const inputDateLocal = new Date(e.target.value); 
  const options = {
    timeZone: selectedTimezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };

  const parts = new Intl.DateTimeFormat('en-CA', options).formatToParts(inputDateLocal);
  const dateParts = {};
  parts.forEach(({ type, value }) => {
    dateParts[type] = value;
  });

  const zonedDate = new Date(
    `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}:${dateParts.second}`
  );

  setScheduleTime(zonedDate.toISOString()); 
};



function formatDateForInput(date, tz) {
  
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const dateParts = {};
  parts.forEach(({ type, value }) => {
    dateParts[type] = value;
  });

  return `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}`;
}


const handleDateChange = (date) => {
  if (!selectedTimezone) return;

  const utcDate = moment.tz(date, selectedTimezone).utc().toDate();

  setScheduleTime(utcDate); 
  setDisplayDate(date);    
};


  // const displayDate = scheduleTime
  //   ? toZonedTime(scheduleTime, selectedTimezone)
  //   : null;

  const getConfigs = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${baseURL}/api/get-configs`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const updated = res.data.configs.map(cfg => ({
        ...cfg,
        saved: true,
      }));
      setConfigs(updated);
    } catch (err) {
     Swal.fire({
               icon: 'error',
               title: 'Error',
               text: 'Something went wrong!',
               confirmButtonColor: 'red',
             });
    }
  };

   const fetchListNames = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await fetch(`${baseURL}/api/user/${userId}/lists`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
  
         if (!response.ok && response.status >= 500) {
          throw new Error(`Server error (${response.status})`);
        }
  
        // Silently return if it's 204 or 404 (no content / not found)
        if (response.status === 204 || response.status === 404) {
          return;
        }
  
        const data = await response.json();
  
        if (!data || typeof data !== "object") {
         
          return;
        }
        setListNames(data);
      } catch (error) {
        Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Something went wrong!',
                  confirmButtonColor: 'red',
                });
      }
    };
    
      const fetchEmails = async () => {
        const token = localStorage.getItem('token');
        if (!selectedList) return;
        try {
          const res = await fetch(`${baseURL}/api/user/${userId}/lists/${selectedList}/emails`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
          );
          const data = await res.json();
          setEmails(data.emails);
          setFirstNames(data.firstName)
        } catch (error) {
         Swal.fire({
                   icon: 'error',
                   title: 'Error',
                   text: 'Something went wrong!',
                   confirmButtonColor: 'red',
                 });
        }
      };
  
  const fetchEmailById = async () => {
  const token = localStorage.getItem('token');
  if (!token) return;

  try {
    const res = await fetch(`${baseURL}/api/get-email/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    if (data?.email) {
      setEmail(data.email);
    } else {
      console.log("No email returned");
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Something went wrong!',
      confirmButtonColor: 'red',
    });
  }
};

  
      const fetchListEmailById = async () => {
      const token = localStorage.getItem('token');
      if (!token || !id || !listName) return;
      try {
        const res = await fetch(`${baseURL}/api/send-list-one/${listName}/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
        );
        const data = await res.json();
        setEmail(data.email);
      } catch (error) {
       Swal.fire({
                 icon: 'error',
                 title: 'Error',
                 text: 'Something went wrong!',
                 confirmButtonColor: 'red',
               });
      }
    }
  
    const handleEmailSelect = (e) => {
      const email = e.target.value;
      setSelectedEmail(email);
      setAppPassword(formData.appPassword);
      const selectedConfig = configs.find(cfg => cfg.fromEmail === email);
      if (selectedConfig) {
        setFormData(prev => ({
          ...prev,
          domain: selectedConfig.domain,
          fromEmail: selectedConfig.fromEmail,
          appPassword: selectedConfig.appPassword,
        }));
      }
    };
  
    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    };
  
  
    const handleDelayChange = (e) => {
      const value = e.target.value;
  
      if (value === 'custom') {
        setIsCustomDelay(true);
        setMailDelayMinutes(null);
      } else {
        setIsCustomDelay(false);
        setMailDelayMinutes(parseInt(value));
      }
    };
  
    const handleCustomDelayInput = (e) => {
      const value = e.target.value;
      setCustomDelay(value);
      setMailDelayMinutes(parseInt(value));
    };
  
  const handleTemplateChange = (e) => {
    const selectedName = e.target.value;
    setSelectedTemplate(selectedName);

     if (incomingTemplate && incomingTemplate.name === selectedName) {
      setFormData(prev => ({
        ...prev,
        message: incomingTemplate.message
      }));
      return;
    }
  
    const selected = templates.find(t => t.name === selectedName);
    if (selected) {
      setFormData(prev => ({
        ...prev,
        message: selected.message
      }));
    }
  };
  
  
    // const handleInsertText = (text) => {
    //   const textarea = textareaRef.current;
    //   if (!textarea) return;
  
    //   const start = textarea.selectionStart;
    //   const end = textarea.selectionEnd;
    //   const before = templateMessage.substring(0, start);
    //   const after = templateMessage.substring(end);
  
    //   const newMessage = before + text + after;
    //   setTemplateMessage(newMessage);
    //   setTimeout(() => {
    //     textarea.focus();
    //     textarea.selectionStart = textarea.selectionEnd = start + text.length;
    //   }, 0);
    // };
  
    const handleInsertText = (text) => {
  if (!quillRef.current) return;

  const quill = quillRef.current.getEditor(); // get Quill editor instance
  const range = quill.getSelection();

  if (range) {
    quill.insertText(range.index, text); // insert variable at cursor
    quill.setSelection(range.index + text.length); // move cursor after inserted text
  } else {
    // if no selection, just append at the end
    quill.insertText(quill.getLength() - 1, text);
  }
};
 const handleSubmit = async (e) => {
  e.preventDefault();

  const token = localStorage.getItem('token');
  const currentDate = new Date().toISOString();

  if (!email && (!scheduleTime || !mailDelayMinutes)) {
    Swal.fire("Missing Fields", "Please enter both Schedule Time and Delay Between Emails to send a campaign.", "warning");
    return;
  }

 const sendIndividualMail = async () => {
  try {
    const payload = {
      recipientEmail: email,
      scheduleTime: scheduleTime || null,
      subject: formData.subject || selectedTemplate,
      message: formData.message,
      date: currentDate,
      domain: formData.domain,
      appPassword: formData.appPassword,
      status: "sent", 
      emailId: individualDraftId || null 
    };

    const url = individualDraftId
      ? `${baseURL}/api/update-individual-draft` 
      : `${baseURL}/api/send-individual-email`; 
    const method = individualDraftId ? "PUT" : "POST";

    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Failed to send individual email.");
    }

    if (result.sentStatus === "bounced") {
  Swal.fire({
    icon: 'error',
    title: 'Bounced!',
    text: 'The email could not be delivered.',
    confirmButtonColor:"#FCB124"
  });
} else {
  Swal.fire({
    icon: 'success',
    title: 'Success!',
    text: 'Your email has been sent',
    confirmButtonColor:"#FCB124",
    confirmButtonText: 'OK',
    willOpen: () => {
      document.querySelector('.swal2-container').style.zIndex = '3000';
    }
  });
  setIsSent(true);
  setFormData({
    subject: "",
    message: "",
    domain: "",
    fromEmail: "",
    appPassword: "",
  });
  setEmail("");
  setSelectedTemplate("");
  setDisplayDate(null);
  setScheduleTime("");
  setMailDelayMinutes("");
  setCustomDelay("");
  setIsCustomDelay(false);
}
   
  } catch (err) {
    Swal.fire("Error", err.message, "error");
  }
};

const sendCampaign = async () => {
  try {
    const isSingleMail = !!email;
    const recipients = isSingleMail ? [email] : emails;
    const names = isSingleMail? [email] : firstNames;

    const payload = {
      campaignId: draftId || null, 
      campaignName: campaignName || "New Campaign",
      scheduleSentTime: scheduleTime || null,
      delayBetweenEmails: mailDelayMinutes || 0,
      recipientList: recipients,
      firstNames: names,
      subject: formData.subject || selectedTemplate,
      message: formData.message,
      domain: formData.domain,
      from: formData.fromEmail,
      appPassword: formData.appPassword,
      date: currentDate,
      sentStatus: "sent" ,
      listName: selectedList
    };

    const url = draftId
      ? `${baseURL}/api/update-campaign-draft`
      : `${baseURL}/api/create-campaign`;

    const method = draftId ? "PUT" : "POST";

    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Failed to send campaign.");
    }

    if (result.sentStatus === "bounced") {
  Swal.fire({
    icon: 'error',
    title: 'Bounced!',
    text: 'Some or all emails bounced. Please check your campaign report.',
    confirmButtonColor:"#FCB124"
  });
} else {
  toast.success(
    isSingleMail
      ? "Mail sent successfully"
      : `${selectedList} list campaign sent successfully`
  );
  setIsSent(true);
}} catch (err) {
    Swal.fire("Error", err.message, "error");
  }
};

function getCurrentUSTime() {
  const now = new Date();

  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(now);
  const dateParts = {};
  parts.forEach(({ type, value }) => {
    dateParts[type] = value;
  });

  return new Date(
    `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}:${dateParts.second}`
  );
}


 if (scheduleTime) {
const scheduleDate = new Date(scheduleTime); // already UTC

  const nowUS = getCurrentUSTime(); 

  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(scheduleDate);
  const dateParts = {};
  parts.forEach(({ type, value }) => {
    dateParts[type] = value;
  });

  const scheduleUS = new Date(scheduleDate.toLocaleString("en-US", {
  timeZone: "America/New_York"
}));


  // const scheduleDateUS = new Date(
  //   `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}:${dateParts.second}`
  // );

  const delay = scheduleUS.getTime() - nowUS.getTime();

  if (delay > 0) {
    Swal.fire("Scheduled", "Your Campaign will be sent at the scheduled time.", "info");

    setTimeout(() => {
      if (fromDraft || fromContacts || fromList) {
        sendIndividualMail();
      } else {
        sendCampaign();
      }
      localStorage.setItem("campaignSent", "true");
    }, delay);
    navigate("/mail");
  } else {
    Swal.fire("Invalid Time", "Please select a future time.", "warning");
  }
}else {
    if (fromDraft || fromContacts || fromList) {
      sendIndividualMail();
    } else {
      sendCampaign();
    }
  }
};

const handleSaveIndividualDraft = async () => {
  const token = localStorage.getItem("token");
  try {
    const payload = {
      recipientEmail: email,
      scheduleTime: scheduleTime || null,
      subject: formData.subject || selectedTemplate,
      message: formData.message,
      domain: formData.domain,
      from: formData.fromEmail,
      appPassword: formData.appPassword,
      status: "draft",
    };

    const response = await fetch(`${baseURL}/api/save-individual-draft`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Failed to save draft.");
    }

    Swal.fire({
      icon: "success",
      title: "Draft Saved",
      text: "Your draft has been saved successfully!",
      timer: 1000,
      showConfirmButton: false,
        willOpen: () => {
        document.querySelector('.swal2-container').style.zIndex = '3000';
      }
    });


    setShowIndividualDraftPopup(false);

    if (draftNavigation?.type === "contacts") {
      navigate("/my-contacts", { state: { openProfileId: draftNavigation.id } });
    } else if (draftNavigation?.type === "list") {
      navigate("/my-list", {
        state: {
          openProfileId: draftNavigation.id,
          selectedListName: draftNavigation.listName,
        },
      });
    }
  } catch (err) {
    Swal.fire("Error", err.message, "error");
  }
};

  
    const handleSaveTemplate = async () => {
  
      const token = localStorage.getItem('token');
  
      if (!templateMessage.trim()) return  Swal.fire({
      icon: 'warning',
      title: 'Empty Message',
      text: 'Message cannot be empty.',
       confirmButtonColor:"#FCB124",
      willOpen: () => {
        document.querySelector('.swal2-container').style.zIndex = '3000';
      }
    });;
  
      const response = await fetch(`${baseURL}/api/save-template`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          name: templateName || null,
          message: templateMessage,
        }),
      });
  
      const data = await response.json();
      if (response.ok) {
        Swal.fire({
           icon: "success",
          text: `Template "${data.template.name}" saved successfully`,
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
          willOpen: () => {
        document.querySelector('.swal2-container').style.zIndex = '3000';
      }
        })
        setIsOpen(false);
        setTemplateMessage('');
        setTemplateName('');
        fetchTemplates();
      } else {
        Swal.fire({
          icon:"warning",
          text:`${data.message}`,
          confirmButtonColor:"#FCB124",
          confirmButtonText:"OK",
          willOpen: () => {
        document.querySelector('.swal2-container').style.zIndex = '3000';
      }
        })
      }
    };
  
  const handleSaveCampaignDraft = async () => {
    const token = localStorage.getItem('token')

  const payload = {
    campaignName,
    scheduleSentTime: scheduleTime,
    delayBetweenEmails: mailDelayMinutes || 0,
    recipientList: emails,
    subject: formData.subject,
    message: formData.message,
    domain: formData.domain,
    from: formData.fromEmail,
  };

  const res = await fetch(`${baseURL}/api/save-draft`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(payload)
  });

  if (res.ok) {
    Swal.fire({
      icon: "success",
      title: "Draft Saved",
      text: "Your draft has been saved successfully!",
      timer: 1000,
      showConfirmButton: false,
        willOpen: () => {
        document.querySelector('.swal2-container').style.zIndex = '3000';
      }
    });
    setShowDraftPopup(false);
    navigate("/mail")
  } else {
    alert("Failed to save draft");
  }
};

const handleDiscardDraft = () => {
  setShowDraftPopup(false);
  navigate("/mail");
};

const handleDiscardIndividualDraft = () => {
  setShowIndividualDraftPopup(false);

  if (draftNavigation?.type === "contacts") {
    navigate("/my-contacts", {
      state: { openProfileId: draftNavigation.id },
    });
  } else if (draftNavigation?.type === "list") {
    navigate("/my-list", {
      state: {
        openProfileId: draftNavigation.id,
        selectedListName: draftNavigation.listName,
      },
    });
  } 
};


  const handleTabClick = (tab) => {
  const tabIndex = tabs.indexOf(tab);
  if (tabIndex <= maxStep) {
    setSelectedTab(tab);
  }
};

const handleNext = () => {
  const currentIndex = tabs.indexOf(selectedTab);
  if (currentIndex < tabs.length - 1) {
    const nextIndex = currentIndex + 1;
    setSelectedTab(tabs[nextIndex]);
    setMaxStep(Math.max(maxStep, nextIndex)); 
  }
};

const handleBack = () => {
  const currentIndex = tabs.indexOf(selectedTab);
  if (currentIndex > 0) {
    setSelectedTab(tabs[currentIndex - 1]);
  }
};

   const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ['link', 'image'],
      ['clean'],
    ],
  }

   useEffect(() => {
      function handleClickOutside(event) {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      }
  
      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen]);

    const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

 const handleBackToContacts = () => {
  if (email && !isSent) {
    setShowIndividualDraftPopup(true);
    setDraftNavigation({ type: "contacts", id: id });
  } else {
    navigate("/my-contacts", { state: { openProfileId: id } });
  }
};

const handleBackToList = (listName, id) => {
  if (email && !isSent) {
    setShowIndividualDraftPopup(true);
    setDraftNavigation({ type: "list", id: id, listName: listName });
  } else {
    navigate("/my-list", { state: { openProfileId: id, selectedListName: listName  } }); 
  }
};




// const handleBackToList = (listName, id) => {
//   navigate("/my-list", { state: { openProfileId: id, selectedListName: listName  } }); 
// };

const handleBackClick = () => {
  if (!isSent) {
    setShowDraftPopup(true);
  } else {
    navigate("/mail");
  }
};

const handleOutsideClick = () => {
  setShowDraftPopup(false);
};


  return (
    <div className="email-form-container">
       <div className='email-campaign'>
        <div className="campaign" >
  {fromCampaignDraft ? (
        <button
          className="company-back"
           onClick={() => navigate("/allmail", { state: { selectedTab: 'All Campaign' } })}
          style={{ width: "100px", textAlign: "center" }}
        >
          <MdOutlineArrowBackIos /> Back
        </button>
      ) :  fromDraft ? (
  <button className="company-back" onClick={() => navigate("/allmail")} style={{width:"100px", textAlign:"center"}}> 
    <MdOutlineArrowBackIos /> Back
  </button> ) : fromContacts ? (
    <div>
      <button className="company-back" onClick={handleBackToContacts}>
        <MdOutlineArrowBackIos />
        <h4>Back</h4>
      </button>
    </div>
  ) : fromList ? (
    <div>
      <button className="company-back" onClick={() => handleBackToList(selectedListName, selectedProfileId)} style={{width:"110px"}}>
        <MdOutlineArrowBackIos />
        <h4>Back to List</h4>
      </button>
    </div>
  ) : (
    <IoMdArrowBack 
      style={{ fontSize: "35px", cursor: "pointer" }}
      onClick={handleBackClick}
    />
  )}

 <p style={{width:"100%"}}>{fromDraft ? "Send Email" 
       :fromContacts
    ? "Send Email to a Contact"
    : fromList
    ? "Send Email to a List Contact"
    : campaignName || "Campaign Name"}
</p> 
  {!fromCampaignDraft && !fromDraft && !fromContacts && !fromList &&  (
    <CiEdit
      style={{
        fontSize: "30px",
        cursor: "pointer",
        paddingTop: "5px",
        marginLeft: "5px",
      }}
      onClick={() => setShowPopup(true)}
    />
  )}
</div>

{showDraftPopup && (
  <div className="draft-popup" onClick={handleOutsideClick}>
    <div className='draft-content' onClick={(e) => e.stopPropagation()}>
      <div className='draft-text'>Your message has not been sent. Do you want to save it in your Drafts folder?</div>
      <button className='draft-save' onClick={handleSaveCampaignDraft}>Save Draft</button>
      <button className='draft-cancel' onClick={handleDiscardDraft}>Discard Draft</button>
    </div>
  </div>
)}

{showIndividualDraftPopup && (
  <div className="draft-popup" onClick={handleOutsideClick}>
    <div className='draft-content' onClick={(e) => e.stopPropagation()}>
      <div className='draft-text'>Your message has not been sent. Do you want to save it in your Drafts folder?</div>
      <button className='draft-save' onClick={handleSaveIndividualDraft}>Save Draft</button>
      <button className='draft-cancel' onClick={handleDiscardIndividualDraft}>Discard Draft</button>
    </div>
  </div>
)}

          {showPopup && (
            <div className="campaign-overlay" >
              <div className="campaign-name-popup"  ref={popupRef}>
                <div className="campaign-popup-header">
                  <div style={{fontSize:"19px", fontWeight:"500"}}>Edit Campaign</div>
                  <button className="campaign-close-btn" onClick={() => setShowPopup(false)}><IoClose /></button>
                </div>
                <div className="campaign-popup-body">
                  <label style={{fontSize:"16px"}}>
                    Campaign Name<span style={{ color: "red" }}> *</span>
                  </label>
                  <input type="text" placeholder="Enter campaign name"  value={campaignName}
            onChange={(e) => setCampaignName(e.target.value)} />
                </div>
                <div className="campaign-popup-footer">
                  <button className="campaign-save-btn" onClick={() => setShowPopup(false)}>Save</button>
                </div>
              </div>
            </div>
          )}
          <div className='date-template'  ref={dropdownRef} style={{ position: "relative" }}>
            <button className='camp-btn' onClick={toggleDropdown} >
              <IoIosAdd style={{ fontSize: "32px", fontWeight: "500"}} /> Create Template
            </button>
             {showDropdown && (
        <div
          className="dropdown-menu"
          style={{
            position: "absolute",
            top: "60px", 
            right: "0",
            background: "#fff",
            width:"200px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            zIndex: "1000",
          }}
        >
          <div style={{ margin: 0, padding: "10px 0" }}>
            <div style={{ padding: "8px 20px", cursor: "pointer", fontSize:"15px", fontWeight:"500" }}
             onClick={() => {
    openModal();      
    setShowDropdown(false); 
  }}>New Template</div>
            <div style={{ padding: "8px 20px", cursor: "pointer" , fontSize:"15px", fontWeight:"500"}} onClick={() => navigate("/template", { state: { from: "campaign" } })}>Template Library</div>
            <div style={{ padding: "8px 20px", cursor: "pointer", fontSize:"15px", fontWeight:"500" }} onClick={() => navigate("/mytemplate", { state: { from: "campaign" } })}>My Templates</div>
          </div>
        </div>
      )}
          </div>
         
           {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content" ref={popupRef}>
            <div className='campaign' style={{textAlign:"left", fontSize:"15px",fontWeight:'500'}}><FaMailBulk/>
             &nbsp;Create Template</div>

              <div  style={{marginTop:"20px", textAlign:"left", fontSize:"15px", marginLeft:"10px", }}>
                Template Name </div>
            <input
              type="text"
              placeholder="Enter your template name"
              style={{width:"560px", border:"0.2px solid rgba(0, 0, 0, 0.25)",
                 height:"22px", borderRadius:"5px", marginTop:"20px", padding:"10px"}}
                  value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
            />
             <select className="send-email-select" style={{width:"300px", height:"40px", borderRadius:"5px", marginTop:"20px", padding:"10px", marginLeft:"10px"}}
              onChange={(e) => handleInsertText(e.target.value)}
                defaultValue="">
             <option value="" disabled>Instant Variables</option>
            <option value="{{name}}">Name</option>
                <option value="{{date}}">Date</option>
                <option value="{{eSendEmailForm}}">SendEmailForm</option>
                         
           </select>
             {/* <textarea
           theme="snow"
        style={{width:"580px", height:"110px", marginTop:"10px", borderRadius:"5px", marginTop:"20px", marginLeft:"10px", border:"1px solid #ccc",}}
           placeholder="Enter your template message..."
        
          name="message"
           value={templateMessage}
              onChange={(e) => setTemplateMessage(e.target.value)}
              ref={textareaRef}
          
        /> */}
           <ReactQuill
  ref={quillRef}
  theme="snow"
  style={{
    width: "580px",
    height: "110px",
    borderRadius: "10px",
    marginTop: "20px",
    marginLeft: "10px"
  }}
  placeholder="Your Message"
  className="sent-date-quill"
  name="message"
  value={templateMessage}
  onChange={(content) => setTemplateMessage(content)} 
  modules={modules}
/>


            <div className="modal-actions">
              <button onClick={closeModal} className="cancel-temp-btn">
                Cancel
              </button>
              <button className="save-temp-btn" onClick={handleSaveTemplate}>Save</button>
            </div>
          </div>
        </div>
      )}
        </div>

      <div className="send-campaign">
  {tabs.map((tab, index) => (
    <div
      key={tab}
      className={` time ${tab.toLowerCase().replace("&", "").replace(" ", "-")} 
        ${selectedTab === tab ? "select-tab" : ""} 
        ${index > maxStep ? "disabled-tab" : ""}`}
      onClick={() => handleTabClick(tab)}
    >
      {tab === "Timing&Schedule" && "Timing & Schedule"}
      {tab === "EmailConfiguration" && "Email Configuration"}
      {tab === "Content&Template" && "Content & Template"}
    </div>
  ))}
</div>


        <form onSubmit={handleSubmit}>
       {selectedTab === "Timing&Schedule" && (
  <div className="tab-content">
    <div className="schedule-delay">
      {/* Timezone Section */}
      <div>
        <div className="schedule-text">
          <FaGlobe className="clock" /> Select Timezone
        </div>
        <div className="schedule-input">
          <select
            className="send-email-select"
            value={selectedTimezone}
            onChange={(e) => setSelectedTimezone(e.target.value)}
            style={{ width: "1000px", height: "40px", borderRadius: "10px" }}
          >
            <option value="">-- Select Timezone --</option>
            {timezones.map((tz, index) => (
              <option key={index} value={tz.value}>
                {tz.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Schedule Sent Time Section */}
      <div>
        <div className="schedule-text">
          <FaClock className="clock" /> Schedule Sent Time (GMT)
        </div>
        <div className="schedule-input">
          <DatePicker
            className="sent-date-input"
            selected={displayDate}
            onChange={handleDateChange}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            timeCaption="Time"
            placeholderText="Select Date & Time"
            dateFormat="yyyy-MM-dd h:mm aa"
          />
        </div>
      </div>

      {/* Delay Section - only show when not fromDraft, fromContacts, fromList */}
      {!fromDraft && !fromContacts && !fromList && (
        <div>
          <div className="schedule-text">
            <GiSandsOfTime className="clock" /> Delay Between Emails
          </div>
          <div className="schedule-input">
            <select
              className="send-email-select"
              style={{ width: "1000px", height: "40px", borderRadius: "10px" }}
              onChange={handleDelayChange}
              value={
                isCustomDelay
                  ? "custom"
                  : typeof mailDelayMinutes === "number"
                  ? mailDelayMinutes.toString()
                  : ""
              }
            >
              <option value="">-- Select Delay --</option>
              <option value="1">1 Minute</option>
              <option value="10">10 Minutes</option>
              <option value="30">30 Minutes</option>
              <option value="custom">Custom</option>
            </select>

            {isCustomDelay && (
              <input
                type="number"
                className="sent-date-input"
                style={{ marginTop: "10px" }}
                min="1"
                placeholder="Enter custom delay in minutes"
                value={customDelay}
                onChange={handleCustomDelayInput}
              />
            )}
          </div>
        </div>
      )}
    </div>

    <div className="email-next" style={{ justifyContent: "flex-end" }}>
      <button className="next-tab" onClick={handleNext}>
        Next <MdKeyboardArrowRight style={{ fontSize: "18px", fontWeight: "600" }} />
      </button>
    </div>
  </div>
)}


      {selectedTab === "EmailConfiguration" && (
        <div className="tab-content">
          <div>
          <div className='schedule-text'> <FaServer className='clock'/> Server </div>
          <div className='schedule-input'>
             <select className="send-email-select" style={{width:"1000px", height:"40px", borderRadius:"10px"}}
            name="domain" value={formData.domain} onChange={handleChange}>
             <option value="">--- Select Server ---</option>
            {availableDomains.map((domain, idx) => (
              <option key={idx} value={domain}>
                {domain.charAt(0).toUpperCase() + domain.slice(1)}
              </option>
            ))}
           </select>
          </div>
           <div className='schedule-text'> <CiAt className='clock'/> Select Email Account </div>
          <div className='schedule-input'>
             <select className="send-email-select" style={{width:"1000px", height:"40px", borderRadius:"10px"}}
           value={selectedEmail} onChange={handleEmailSelect} >
             <option value="">Select Email</option>
             {configs.map((config, idx) => (
              <option key={idx} value={config.fromEmail}>
                {config.fromEmail} ({config.domain})
              </option>
            ))}
                         
           </select>
          </div>
           <div className='schedule-text'> <FaUserFriends className='clock'/> Select Recipient List </div>
          <div className='schedule-input'>
             {!id ?
             <select className="send-email-select" style={{width:"1000px", height:"40px", borderRadius:"10px"}}
              id="list-select"
                value={selectedList}
                 onChange={(e) => setSelectedList(e.target.value)}
              >
              <option value="--Select a list --">Select Recipient List</option>
                   {listNames.map((name, idx) => (
                <option key={idx} value={name}>
                  {name}
                </option>
              ))}  
           </select> : <input type='text' className="sent-date-input" disabled={email} style={{width:"1000px", height:"40px", borderRadius:"10px"}} 
           value={email} onChange={(e) => setEmail(e.target.value)} readOnly 
            />}
           {Array.isArray(emails) && emails.length > 0 && (
            <div>
              <h4>Emails in selected list:</h4>
              <ul>
                {emails.map((email, idx) => (
                  <li key={idx}>{email}</li>
                ))}
              </ul>
            </div>
          )}
          </div>
          
         </div>
        
            <div className='email-next'>
               <button className='back-tab' onClick={handleBack}  >
              <MdKeyboardArrowLeft style={{fontSize:"18px", fontWeight:"600"}} /> Back
            </button>
          <button className='next-tab' onClick={handleNext}> Next <MdKeyboardArrowRight style={{fontSize:"18px", fontWeight:"600"}} /></button>
        </div>
        </div>
      )}

      {selectedTab === "Content&Template" && (
        <div className="tab-content">
          <div>
          <div className='schedule-text'>Template </div>
          <div className='schedule-input'>
             <select className="send-email-select" style={{width:"1000px", height:"40px", borderRadius:"10px"}}
             value={selectedTemplate}
              onChange={handleTemplateChange} >
             <option value="">Select Template</option>
              {incomingTemplate && (
          <option value={incomingTemplate.name}>{incomingTemplate.name}</option>
        )}

          {templates
    .filter(t => !incomingTemplate || t.name !== incomingTemplate.name)
    .map((template, index) => (
      <option key={index} value={template.name}>
        {template.name}
      </option>
  ))}
           </select>
          </div>
           <div className='schedule-text'>Subject </div>
          <div className='schedule-input'>
             <input type="text" className='sent-date-input' name='subject' value={formData.subject}  onChange={(e)=>setFormData({...formData, subject: e.target.value})} placeholder='Enter your email subject' style={{width:"1000px", height:"40px", borderRadius:"10px"}}/>
          </div>
           <div className='schedule-text'> Message </div>
             <div className='schedule-input'>
            <ReactQuill
           theme="snow"
        style={{width:"1000px", height:"100px", borderRadius:"10px"}}
           placeholder="Your Message"
         className='sent-date-quill'
          name="message"
         value={formData.message}
          onChange={(value) => setFormData(prev => ({ ...prev, message: value }))}
          modules={modules}
        />
        </div>
         </div>
          <div className='email-next'>
            <button className='back-tab' onClick={handleBack}>
              <MdKeyboardArrowLeft style={{fontSize:"18px", fontWeight:"600"}} /> Back
            </button>
             <button className='next-tab' onClick={handleNext}> Send <IoMdSend style={{fontSize:"18px", fontWeight:"600"}} /></button>
            </div>
            
        </div>
      )}
      </form>
    </div>
  )
}

export default Campaign